import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lib-ikp-header-logo',
  standalone: true,
  imports: [NgOptimizedImage],
  // Acceptable to exceed max inline declarations here as this is only a logo, no complexity!
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  template: `<img
    ngSrc="assets/icon/header-logo.svg"
    alt="Kundenportal für Großunternehmen Logo"
    class="logo"
    width="232"
    height="32"
    priority
  />`,
})
export class HeaderLogoComponent {}
